export const NO_SCENE_KEY = 'simple';
export const PRODUCT_VARIANT_LINK_GROUP_NAME_DEFAULT = 'default';
export const PRODUCT_UID_DELIMITER = ',';
export const PRODUCT_WIZARD_ROUTE_VARIANTS = ['/catalogue/stores/current/products/wizard/variants'];
export const PRODUCT_WIZARD_ROUTE_MEDIA = ['/catalogue/stores/current/products/wizard/media'];
export const PRODUCT_WIZARD_ROUTE_DETAILS = ['/stores/current/products/wizard/details'];
export const PRODUCT_WIZARD_ROUTE_PRICES = ['/stores/current/products/wizard/prices'];
export const PRODUCT_WIZARD_ROUTE_VARIANTS_MAPPING = ['/stores/current/products/wizard/variants-mapping'];
